module.exports = __webpack_public_path__ + "img/AdrianInsta_Final.fc91b25b.jpg";